<!--
/*
 * This file is part of OrangeHRM Inc
 *
 * Copyright (C) 2020 onwards OrangeHRM Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <g transform="matrix(0.225412, 0, 0, -0.225412, -3.45313, 503.056793)">
    <path
      d="M695 2086 c-485 -95 -777 -575 -634 -1043 79 -259 283 -462 543 -542 37 -11 71 -21 75 -21 4 0 26 26 48 58 l42 59 -79 17 c-128 27 -230 85 -331 185 -138 138 -202 291 -202 486 0 301 187 556 478 652 69 23 97 27 205 27 108 0 136 -4 205 -27 87 -29 174 -77 245 -136 l45 -37 50 18 c28 10 56 21 64 24 10 3 0 19 -35 55 -92 95 -237 178 -374 213 -88 23 -257 29 -345 12z"
    />
    <path
      d="M790 1488 l0 -233 -141 -141 -141 -141 44 -31 45 -31 156 157 157 157 0 248 0 247 -60 0 -60 0 0 -232z"
    />
    <path
      d="M1492 1660 c-198 -41 -335 -219 -319 -413 8 -87 49 -177 111 -242 25 -27 45 -49 43 -49 -32 -10 -151 -81 -186 -111 -163 -139 -241 -317 -241 -556 0 -155 -74 -139 663 -139 524 0 626 2 643 14 17 13 19 27 18 143 -2 205 -51 342 -168 469 -56 62 -193 164 -220 164 -6 0 -17 4 -25 9 -10 7 -4 18 27 49 238 238 92 637 -244 666 -33 3 -78 1 -102 -4z m196 -136 c95 -47 152 -141 152 -249 0 -191 -188 -322 -372 -259 -184 62 -241 309 -105 453 79 83 221 107 325 55z m7 -656 c89 -19 174 -68 250 -143 113 -112 165 -234 165 -387 l0 -78 -545 0 -545 0 0 89 c0 154 55 278 171 387 140 131 307 175 504 132z"
    />
  </g>
</template>
